// extracted by mini-css-extract-plugin
export default {"footer_terms":"TermsFooter_footer_terms__1zCOR","footer_content":"TermsFooter_footer_content__eoBME"};